/** Shown while the views are the cached mail because Outlook is not
 *  answering (lib/cacheState.ts): what you are seeing, how old it is, and
 *  that changes wait for Outlook. Disappears with the first fresh answer. */
import { useEffect, useState } from "react";
import { CloudOff } from "lucide-react";
import { getCacheState, onCacheState } from "../lib/cacheState";

export function StaleCacheBanner() {
  const [s, setS] = useState(getCacheState);
  const [, tick] = useState(0);
  useEffect(() => onCacheState(setS), []);
  useEffect(() => {
    if (!s.stale) return;
    const t = window.setInterval(() => tick((n) => n + 1), 30_000);
    return () => window.clearInterval(t);
  }, [s.stale]);
  if (!s.stale || !s.syncedAt) return null;
  const mins = Math.max(1, Math.round((Date.now() - s.syncedAt) / 60_000));
  const at = new Date(s.syncedAt).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return (
    <div role="status" className="wov-fade mb-2 flex items-center gap-2 rounded-lg bg-amber-50 px-3 py-1.5 text-[12px] text-amber-900 ring-1 ring-amber-200 dark:bg-amber-950/40 dark:text-amber-100 dark:ring-amber-800/60">
      <CloudOff className="h-3.5 w-3.5 flex-shrink-0" />
      <span>
        Outlook isn't answering. Showing your mail as of <b>{at}</b> ({mins} min ago); changes and new mail wait until it is back.
      </span>
    </div>
  );
}
